import { createMuiTheme } from '@material-ui/core/styles';

const NextPortTheme = createMuiTheme({
    palette: {
        primary: {
        light: '#476499',
        main: '#123a6b',
        dark: '#001540',
        contrastText: '#fff',
        },
        secondary: {
        light: '#8fccff',
        main: '#5b9bd5',
        dark: '#1e6da3',
        contrastText: '#fff',
        },
    },
    overrides: {
        MuiTypography:{
            gutterBottom:{
                marginBottom: '8px'
            }
        },
        MuiCard: {
            root: {
                width: '275px',
            }
        },
        MuiCardHeader: {
            title: {
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            }
        },
      },
});

export default NextPortTheme


// WEBPACK FOOTER //
// ./src/theme.tsx